import * as React from "react"

// Note: The `.crawler-callout-content` class is used by the support search indexer
/**
 * @param {'info' | 'confirmation' | 'warning' | 'error'} type - The type of feedback message.
 * @param {boolean} icon - Whether to display the icon.
 * @param {string} className - Additional classes to apply to the feedback message.
 * @param {React.ReactNode} children - The content of the feedback message.
 * @returns {React.ReactNode} The feedback message component.
 */
const FeedbackMessage = ({ type, icon = true, className = "", children }) => {
  return (
    <div
      className={`feedback-message crawler-callout-content mt-5 mb-5 ${className}`}
      data-type={type}
    >
      {icon && (
        <div className="feedback-message__icon-col">
          <i className="feedback-message__icon"></i>
        </div>
      )}

      <div className="feedback-message__content">{children}</div>
    </div>
  )
}

export default FeedbackMessage
